import { APICore, INSURANCE_URL } from './apiCore';
import { InsurancePolicy } from '../../interfaces/InsurancePolicy';
import { DocumentType } from '../../interfaces/SignedDocument';

const api = new APICore();

export const getInsurancePolicies = (params: { clientId?: string; insuranceId?: string; branch?: string; profile?: boolean }) => {
    const relativeUrl = '/policy';
    return api.get(`${INSURANCE_URL}${relativeUrl}`, params);
};

export const getOperationPolicies = (params: { clientId?: string; insuranceId?: string }) => {
    const relativeUrl = '/policy/operational';
    return api.get(`${INSURANCE_URL}${relativeUrl}`, params);
};

export const getPoliciesList = (params: any) => {
    const relativeUrl = '/policy/list';
    return api.get(`${INSURANCE_URL}${relativeUrl}`, params);
};

export const getPolicyNumbers = (params: any) => {
    const relativeUrl = '/policy/policy-numbers';
    return api.get(`${INSURANCE_URL}${relativeUrl}`, params);
};

export const exportPoliciesList = (params: any) => {
    const relativeUrl = '/policy/export';
    return api.getFile(`${INSURANCE_URL}${relativeUrl}`, params);
};

export const generateInsuranceForms = (params: { insuranceId: string; documentType: DocumentType; preview: boolean }) => {
    const relativeUrl = '/insurance/generate-forms';

    if (params.preview) return api.getFile(`${INSURANCE_URL}${relativeUrl}`, params);
    else return api.get(`${INSURANCE_URL}${relativeUrl}`, params);
};

export const createInsurancePolicy = (body: any) => {
    const relativeUrl = '/policy';
    return api.create(`${INSURANCE_URL}${relativeUrl}`, body);
};

export const editInsurancePolicy = (id: string, policy: any) => {
    const relativeUrl = '/policy/' + id;
    return api.update(`${INSURANCE_URL}${relativeUrl}`, policy);
};

export const deleteInsurancePolicy = (id: string) => {
    const relativeUrl = '/policy/' + id;
    return api.delete(`${INSURANCE_URL}${relativeUrl}`);
};

export const restoreInsurancePolicy = (id: string) => {
    const relativeUrl = `/policy/${id}/restore`;
    return api.update(`${INSURANCE_URL}${relativeUrl}`, {});
};

export const getPremiumChangeTable = (policyId: string) => {
    const relativeUrl = `/policy/${policyId}/premium-change-table`;
    return api.get(`${INSURANCE_URL}${relativeUrl}`, {});
};

export const exportPremiumChangeTable = (policyId: string) => {
    const relativeUrl = `/policy/${policyId}/premium-change-table/export`;
    return api.getFile(`${INSURANCE_URL}${relativeUrl}`, {});
};

export const getClientProfilePolicies = (params: { clientId: string; branch?: string }) => {
    const relativeUrl = '/policy/client-profile';
    return api.get(`${INSURANCE_URL}${relativeUrl}`, params);
};

export const generateInsuranceHatama = (params: { insuranceId: string; preview?: boolean }) => {
    const relativeUrl = '/insurance/generate-hatama';
    return api.getFile(`${INSURANCE_URL}${relativeUrl}`, params);
};

export const generateInsurancePricing = (params: { policyId: string; preview?: boolean }) => {
    const relativeUrl = `/policy/${params.policyId}/generate-pricing`;
    return api.getFile(`${INSURANCE_URL}${relativeUrl}`, { preview: params.preview });
};

// Calculate premium change table without a saved policy (for company comparison)
export const calculatePremiumChangeTable = (params: {
    company: string;
    branch: string;
    totalCoverage?: number;
    insuranceDiscount?: string;
    insuredList: Array<{
        idNumber: string;
        name: string;
        dateOfBirth?: Date | string;
        gender?: string;
        smokerStatus?: string;
        occupationMultiplier?: number;
    }>;
    insuredPersonCoverages?: Array<{
        insuredPerson: { idNumber: string };
        selectedCoverages: Array<{ coverageType: string; insurancePricingId: string }>;
    }>;
    mortgageDetails?: Array<{ amount: number; period: number; interestRate: number }>;
}) => {
    const relativeUrl = '/policy/calculate-premium-change-table';
    return api.create(`${INSURANCE_URL}${relativeUrl}`, params);
};
